import moment from "moment"

export const getPrettyDate = (date) => {
  return new Date(date).toDateString().slice(4)
}

export const getRecentMonthDateString = () => {
  let today = moment().format('YYYY-MM-DD')
  let lastMonth = moment().subtract(1,'months').format('YYYY-MM-DD');
  return lastMonth+','+today
}

export const getRecentYearDateString = () => {
  let today = moment().format('YYYY-MM-DD')
  let lastMonth = moment().subtract(1,'years').format('YYYY-MM-DD');
  return lastMonth+','+today
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  getPrettyDate,
  getRecentMonthDateString
}